@if (vm(); as vm) {
    @if (!vm.isActiveTreeItemGroup) {
        @if (vm.navigationTree?.length) {
            <div class="navigation-group" (libFocusOutside)="!isMobileView() && focusOutsideEvent.emit()">
                <div class="navigation-group__item">
                    <p
                        class="navigation-group__item-link"
                        [class.active]="vm.activeTreeItem === null"
                        #shopAllAction
                        role="button"
                        (libAccessibleClick)="onShopAllClick()"
                        (mouseenter)="onMouseEnterShopAll()"
                    >
                        <span class="navigation-group__item-link-title"> Shop All </span>
                    </p>
                </div>
                @for (item of vm.navigationTree; track item.id) {
                    <div class="navigation-group__item">
                        <p
                            class="navigation-group__item-link"
                            [class.active]="vm.activeTreeItem?.id === item.id"
                            role="button"
                            (libAccessibleClick)="clickNavItem(item)"
                            (mouseenter)="onMouseEnterItem(item)"
                        >
                            <span class="navigation-group__item-link-title">{{ item.name }}</span>
                        </p>
                    </div>
                }
            </div>
        }
    }
    @if (vm.activeTreeItem && vm.isActiveTreeItemGroup) {
        <lib-navigation-links-group
            [headerTitle]="vm.activeTreeItem.name"
            [navigationTree]="vm.activeTreeItem.group!"
            [parent]="vm.activeTreeItem"
            (backEvent)="onBack()"
            (closeEvent)="closeEvent.emit()"
            (focusOutsideEvent)="focusOutsideEvent.emit()"
        />
    }
}
